import React from 'react'
import PageHeader from "../components/PageHeader";
import { vedpathshalaImg } from '../assets/assets.js';
import "../css/vedpathshala.css";
const Vedpathshala = () => {
    return (
        <>  
            <PageHeader title="वेद पाठशाळा" path="/vedpathshala" name=" Vedpathshala" />
         
  <div className="vedpathshala-section">
    {/* <h1 className='vedpathshala-section-title'>वेद पाठशाळा माहिती</h1> */}
    {/* container holds all the sub-section */}
    <div className="vedpathshala-container">
      <div className="vedpathshala-sub-section">
       <div className='vedpathshala-img-container'>
       <img className="vedpathshala-image" src={vedpathshalaImg.ved_img_1} alt="" />
       </div>
         <div className="vedpathshala-info-container">
              <center><h3>॥ हरिःॐ॥</h3> </center> 
              <center>
              <div className='vedpathshala-info-container-shlok'>
              यस्य नि:श्वसितं वेदा यो वेदेभ्योऽखिलं जगत् । <br />
               निर्ममे तमहं वन्दे विद्यातीर्थं महेश्वरम् ॥
                </div>
              </center>
              <p>  &nbsp;  &nbsp;  &nbsp; &nbsp;   &nbsp; &nbsp; भारतीय संस्कृतीत वेदांना अनन्यसाधारण महत्व आहे. वेदांचे महत्व ऋषी-महर्षींनी अंतर्ज्ञानाने जाणून घेवून सर्वांच्या कल्याणार्थ प्रगट केले. हिंदू राष्ट्राची जीवन प्रणाली एका खंबीर अधिष्ठानावर उभी आहे. वेद व देव भारतीय संस्कृतीचे मूलाधार आहेत. वेद वाङ्मय जगातील सर्वाधिक प्राचीन वाङ्मय आहे. विज्ञान युगातही त्याचे महत्व अबाधित आहे. काळाच्याओघात काही संकटे, बदलत्या विचारधारा, प्रतिकूल परिस्थितीमुळे वेदज्ञान, त्यातील रहस्य, गूढज्ञान लुप्त होण्याची भिती निर्माण झाली आहे. अशा स्थितीतही काही संस्कृतिनिष्ठ वेदभक्तांनी ईश्वरी आशीर्वाद, प्रबल इच्छाशक्तीच्या सामर्थ्यावर वेदज्ञानाचा वारसा प्राणपणाने जपला. वेदांच्या संरक्षण व संवर्धनाचे कार्य हाती घेतले. अशा काही ज्येष्ठ-श्रेष्ठ महात्म्यां मधील एक थोर विभूती म्हणजेच परमपूज्य श्रीसद्गुरू वेंकटेश दाजीमहाराज हे होत. श्रीदाजीमहाराजांचे अलौकिक कार्य</p>
              <p>
              परभणी जिल्ह्यात परमपावन वात्सल्यमयी गोदामातेच्या कुशीत वसलेले पूर्णा तालुक्यातील श्रीक्षेत्र धनगर टाकाळी हे छोटेसे खेडेगाव. येथे परमपूज्य श्रीसद्गुरू वेंकटेश दाजीमहाराजांचा जन्म शके 1784 इ.स. 1832 साली झाला. लहानपणापासूनंच वेदमाता गायत्री, वेदपुरुष यांच्याबद्दल मनात नितांत श्रद्धा, वेदाध्ययनाची जिज्ञासा, जनकल्याणाची आकांक्षा त्यांनी बाळगलेली होती अल्पावधीतंच एक महान गायत्री उपासक दशग्रंथी घनपाठी वैदिक, ग्रहालाघवादि पंचांग ज्योतिष व धर्मशास्त्राचे प्रगाढ पंडित म्हणून महाराजांची  ख्याती सर्वदूर पसरली.महाराजांची योग्यता जाणून संतवर्य योगिराज श्रीगंगाजीबापूमहाराज यांनी महाराजांना दिव्य योगशक्ती प्रदान केली.
              </p>
             <center>
             <div className='vedpathshala-info-container-shlok'>
              निष्काम करा वेदाध्ययन । तैसेच नित्य अध्यापन । <br />
               परंपरा चालवावी जाण । निष्कारण वेदांची ॥
               </div>
             </center>
              <p>ही महाराजांची जीवनसाधना होती. प्रभावी वेदाध्यापनातून महाराजांनी अनेक उत्तम वैदिक घडवले. अनेक आर्तजनांना दुःखमुक्त केले. अनेक दुर्जनांना सन्मार्गी लावले. समाजशीलता जपली, जनकल्याणार्थ देह झिजविला. मनोभावे गोसेवा देखील केली. </p>
              <center>
              <div className='vedpathshala-info-container-shlok'>
               गोदा असे ज्येष्ठ बहिण ।  भागीरथीचे कनिष्ठपण | <br />
गोदातट श्रेष्ठ विद्यापीठ जाण । व्हावे प्रतिष्ठान वेदांचे ॥ <br />
येथेचालावा वेदाभ्यास | धर्मशास्त्र वेदांग ज्योतिष । <br />
षड्दर्शनार्थ्यांचा छात्रावास । टाकळीत असावा ॥
      </div> 
              </center>
      <p>
      ही महाराजांची आंतरिक इच्छा व “श्री” च्या आचार-विचारांची परंपरा त्यांचे पुत्र श्री.सिद्धमहाराज व पौत्र श्री.अनंतमहाराज यांनी आजन्म सांभाळली तर प्रपौत्र श्री. उमेशमहाराजांनी “श्रीं” च्या वेदशास्त्रादींच्या प्रचार-प्रसाराचे व्रत पुढे नेत, सचिदानंद वेद स्वाध्याय प्रतिष्ठान' च्या स्वरूपात साकारले आहे. तसेच “श्रीं”  चे सिद्धिगुरु, गोभक्त, योगिराज गंगाजी बापू यांच्या नावाने गोसेवा प्रकल्पाच्या माध्यमातून गोरक्षण-संवर्धनाचे व्रत आजन्म स्वीकारले आहे. “श्रीं” च्या आशीर्वादाच्या पाठबळावर हे कार्य उत्तरोत्तर प्रगतीच्या दिशेने वाटचाल करत आहे. 
      </p>

           </div>
          </div>

          <div className="vedpathshala-sub-section">
       <div className='vedpathshala-img-container'>
       <img className="vedpathshala-image" src={vedpathshalaImg.ved_img_2} alt="" />
       </div>
         <div className="vedpathshala-info-container">
              <h3>सच्चिदानंद वेदस्वाध्याय प्रतिष्ठान</h3>
              <p>
              &nbsp;  &nbsp;  &nbsp; &nbsp;   &nbsp; &nbsp; वेद-शास्त्राच्या अध्ययन-अध्यापनाची परम्परा पुढे अखंडितपणे चालविण्याच्या हेतूने 29/11/1998 रोजी सिद्धियोग मुहूर्तावर गुरुकुलाची स्थापना झाली. परमपावन गोदावरी नदीचा प्रवाह टाकळी येथे अर्धचंद्राकार स्वरूपाचा आहे. त्यामुळे या क्षेत्रास योगपीठाचे महत्व प्राप्त आहे. श्रीसद्गुरू वेंकटेश दाजीमहाराज यांना प्रत्यक्ष वेदमाता गायत्रीने महायज्ञ करण्यासाठी जी जागा दृष्टांतामध्ये सूचित केली होती व ज्या जागी जवळपास दीडशे वर्षांपूर्वी झालेल्या महायज्ञात जगद्गुरु शंकराचार्यां समवेत श्रीसाईबाबा, श्रीदासगणूमहाराज, प.प. श्रीवासुदेवानंद सरस्वती टेंब्येस्वामी यांची प्रत्यक्ष उपस्थिती लाभली होती त्या पवित्र यज्ञभूमीवर गुरुकुलाच्या वास्तूची स्थापना झाली.
              </p>

             <p>
             अवघ्या 5 विद्यार्थ्यांपासून सुरु झालेल्या गुरुकुलाचा विस्तार वेदाध्ययनाध्यापनाच्या कार्यसातत्याने, गुरुकुलास भेटी देणाऱ्या अनेक 
             संत–महात्म्यांच्या आशीर्वादाने व वेदप्रेमी सद्गुरुभक्त मंडळींच्या सक्रिय सहभागातून उत्तम प्रकारे होत गेला. प्रतिष्ठानच्या कार्यगुणवत्तेची दखल घेत, मानव संसाधन विकास मंत्रालय, भारत सरकार अंतर्गत 'महर्षि सांदीपनी राष्ट्रीय वेदविद्या प्रतिष्ठान, उज्जैन' च्या वतीने प्रतिष्ठानास शासनमान्यता प्रदान करण्यात आली. तसेच विभागातील चारही वेदांच्या परीक्षांचे शासकीय केंद्र म्हणून नियुक्तीहि करण्यात आली.
             </p>
             <p>
             इ.स.2010 मध्ये पुणे येथील राधादामोदर प्रतिष्ठानच्या वतीने देण्यात येणारा 
             "श्रीदासगणूमहाराज पुरस्कार" हा मानाचा पुरस्कार प्रतिष्ठानास प्राप्त झाला. आजवर गुरुकलातून वेद व याज्ञिक विषयांचे मिळून सुमारे 300 हून अधिक विद्यार्थ्यांनी अध्ययन पूर्ण केले आहे. आजवर भारतातील अनेक ठिकाणच्या वैदिक परीक्षांमध्ये गुरुकुलातील विद्यार्थ्यांनी विशेष प्राविण्य संपादन करून प्रतिष्ठानच्या शैक्षणिक क्षेत्रातील यशात भर टाकली आहे.
             </p>
            
           </div>
          </div>

          <div className='vedpathshala-sub-section'>
               <h3>वैशिष्ट्ये</h3>
                <ul>
                  <li>वृक्षराजींनी समृद्ध व सुशोभित निसर्गरम्यपरीसर. </li>
                  <li>अध्यापक, विद्यार्थ्यांच्या निवास, अध्ययन व्यवस्था. </li>
                  <li>चारही वेद, संस्कृत इ.च्या अध्ययन–अध्यापनाच्या व्यवस्थेबरोबरंच अध्ययनार्थी शालेय औपचारिक शिक्षणापासून वंचित राहू नयेत म्हणून शालेय विषयांचेहि नियमित वर्ग. </li>
                  <li>	मराठवाड्यात अलिकडच्या काळात प्रथमंच ऋग्वेदाच्या घनपाठापर्यंतच्या अध्ययनवर्गास मोठया विद्यार्थी संख्येनिशी प्रारंभ गुरुकुलात महर्षि सांदीपनी राष्ट्रीय वेदविद्या प्रतिष्ठान, उज्जैनच्या निर्धारित सप्तवर्षात्मक वेद तसेच सामाजिक विज्ञान, गणित, संस्कृत व इंग्रजी इ. चा अभ्यासकम पूर्ण करणाऱ्या विद्यार्थ्यांना' महर्षि सांदीपनी राष्ट्रीय वेदविद्या प्रतिष्ठान, उज्जैन ' यांचाकडून' वेदविभूषण' ही बारावी समकक्ष असलेली पदवी प्राप्त होते. </li>
                  <li>	नित्य यज्ञानुष्ठानाच्या माध्यमातून अग्निदेवतेची उपासना. </li>
                  <li>	समृद्ध ग्रंथालय </li>
                  <li>	विद्यार्थ्यांच्या ज्ञानेपासनेबरोबरंच सूर्यनमस्कार, योगसाधना, योगासने, व्यायाम इ. च्या माध्यमातून आध्यात्मिक उपासना तसेच बलोपासनेकडे विशेष लक्ष. </li>
                  <li>	विद्यार्थ्यांना संगीत गायन-वादन, हरिकीर्तन, गीता, भागवत इत्यादींचे देखील मार्गदर्शन. </li>
                  <li>	संतवर्य योगिराज गंगाजीबापू महाराज गोसेवा प्रकल्पाच्या माध्यमातून देशी गाईचे संरक्षण व संवर्धन.</li>
                </ul>      
          </div>

          <div className='vedpathshala-sub-section'>
               <h3>प्रतिष्ठानची भावी उद्दिष्टे</h3>
               <ul>
                <li>यज्ञशाळा व ध्यानकक्ष</li>
                <li>दुर्मिळ होत चाललेल्या वेदशाखा तसेच ज्योतिष व षट्शास्त्रांचे  अध्ययन–अध्यापन</li>
                <li>वेद  शास्त्रांच्या महापरीक्षांचे आयोजन. </li>
                <li>सांस्कृतिक कार्यक्रमांसाठी भव्य सभागृह</li>
                <li>आरोग्य चिकित्सालय व व्यायामशाळा </li>
                <li>सौरऊर्जा व गोबरगॅसप्रकल्प</li>
                <li>कार्यविस्तारीसाठी अधिक विस्तृत भूखंड</li>
               </ul>
          </div>

         
        


        </div>
     
    </div>
  </>
    );
}


export default Vedpathshala